import React from "react"
import { Button, Container, Card, CardBody, Row, Badge, Col } from "reactstrap"
import { Link } from "react-router-dom"
import Select2 from "react-select2-wrapper"

class MerchantsListCards extends React.Component {
  state = {
    sortBy: "name",
    merchants: [],
  }

  componentDidMount() {
    const { merchants } = this.props
    if (merchants && merchants.length > 0) {
      this._sortMerchants(merchants, this.state.sortBy)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log('Component Did Update');
    const prevMerchants = prevProps.merchants
    const currMerchants = this.props.merchants
    // console.log(JSON.stringify({ prevMerchants: prevMerchants.length > 0, currMerchants: currMerchants.length > 0 }, null, 4 ));
    if (
      prevMerchants &&
      prevMerchants.length > 0 &&
      currMerchants &&
      currMerchants.length === 0
    ) {
      this.setState({
        merchants: [],
      })
    } else if (
      prevMerchants &&
      currMerchants &&
      JSON.stringify(prevMerchants) !== JSON.stringify(currMerchants)
    ) {
      // console.log('Debug-2');
      this._sortMerchants(currMerchants, this.state.sortBy)
    } else if (prevState.sortBy !== this.state.sortBy) {
      // console.log('Debug-3');
      this._sortMerchants(currMerchants, this.state.sortBy)
    }
  }

  _sortMerchants(merchants, sortParam) {
    if (merchants && merchants.length > 0 && sortParam) {
      let tempMerchants = [...merchants]
      switch (sortParam) {
        case "name":
          tempMerchants.sort((a, b) => {
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
              return 1
            }
            if (a.name.toLowerCase() < b.name.toLowerCase()) {
              return -1
            }
            return 0
          })
          this.setState({ merchants: tempMerchants })
          break
        case "price":
          tempMerchants.sort((a, b) => {
            const aPrices =
              a.vehicleType
                .flatMap(({ packages }) => packages)
                ?.map((pkg) => (isNaN(pkg.cost) ? 0 : parseInt(pkg.cost))) || []
            const bPrices =
              b.vehicleType
                .flatMap(({ packages }) => packages)
                ?.map((pkg) => (isNaN(pkg.cost) ? 0 : parseInt(pkg.cost))) || []
            const aMin = Math.min(...aPrices)
            const bMin = Math.min(...bPrices)
            return aMin < bMin
          })
          this.setState({ merchants: tempMerchants })
          break
        case "jobs":
          tempMerchants.sort((a, b) => {
            return (b.totalOrders || 0) - (a.totalOrders || 0)
          })
          this.setState({ merchants: tempMerchants })
          break
        default:
          break
      }
    }
  }

  _handleSort(e, name) {
    if (e && name) {
      const value = e.target.value
      this.setState({ [name]: value })
    }
  }

  render() {
    return (
      <>
        <div className="header pt-5 pb-7 flex-wrapper">
          <Container className="chift-container">
            <div className="header-body">
              <Row className="mb-2 sortby">
                <Col sm={4}>
                  <span>Merchants in {this.props.zipCode}</span>
                </Col>
                <Col sm={3}>
                  <span className="sortbyTxt">sort by </span>
                  <Select2
                    value={this.state.sortBy}
                    data-minimum-results-for-search="Infinity"
                    className="form-control faver-sort"
                    defaultValue={"name"}
                    onChange={(e) => this._handleSort(e, "sortBy")}
                    data={[
                      { id: "name", text: "Name" },
                      { id: "price", text: "Price" },
                      { id: "jobs", text: "Jobs" },
                    ]}
                  />
                  <i className="fa fa-angle-down" aria-hidden="true"></i>
                </Col>
              </Row>
              <Row className="align-items-center">
                {this.props.merchants && (
                  <MerchantCards
                    zipCode={this.props.zipCode}
                    merchants={this.state.merchants}
                  />
                )}
              </Row>
            </div>
          </Container>
        </div>
      </>
    )
  }
}

function MerchantCards({ zipCode, merchants }) {
  if (merchants && merchants.length > 0) {
    const getMerchantLowestPrice = (merchant) => {
      let prices = []
      if (merchant && merchant.vehicleType && merchant.vehicleType.length > 0) {
        merchant.vehicleType.forEach((item) => {
          if (item.packages && item.packages.length > 0) {
            item.packages.forEach((pkg) => prices.push(parseInt(pkg.cost)))
          }
        })
      }
      let lowestPrice = Math.min(...prices)
      lowestPrice = lowestPrice > 0 ? lowestPrice : 0
      return lowestPrice
    }
    return (
      <>
        {merchants.map((merchant, idx) => {
          const pathname = `/merchant/${merchant.merchantId || ""}`
          return (
            <Col lg="12" key={idx}>
              <Card className="merchantListcards">
                <CardBody>
                  <Row className="align-items-center">
                    <Col className="col-auto" xs="2">
                      <span
                        className="avatar avatar-xl rounded-rectangle"
                        onClick={(e) => e.preventDefault()}
                      >
                        <img
                          alt={merchant.name}
                          src={
                            merchant.logo ||
                            require("assets/img/theme/light-grey-bg.png")
                          }
                        />
                      </span>
                    </Col>
                    <Col className="col-auto" xs="10">
                      <Row>
                        <Col>
                          <Link
                            to={{
                              pathname,
                              state: {
                                merchant,
                                zipCode,
                              },
                            }}
                          >
                            <h2 className="mb-0 ml-2">{merchant.name}</h2>
                            <span
                              className="text-muted text-sm mb-0 ml-2"
                              style={{ fontWeight: "bold" }}
                            >
                              {" "}
                              Starts from ${getMerchantLowestPrice(merchant)}
                            </span>
                          </Link>
                        </Col>
                        <Col md="3">
                          <div className="ml-2">
                            <Badge
                              color="primary"
                              className="faver-verified-badge"
                              pill
                            >
                              Verified{" "}
                              <i
                                className="fa fa-check-circle text-primary"
                                aria-hidden="true"
                              ></i>
                            </Badge>
                            <span className="display-6 mb-0">
                              4.7
                              <i className="fa fa-star" aria-hidden="true"></i>
                              <i className="fa fa-star" aria-hidden="true"></i>
                              <i className="fa fa-star" aria-hidden="true"></i>
                              <i className="fa fa-star" aria-hidden="true"></i>
                              <i className="fa fa-star" aria-hidden="true"></i>
                            </span>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <div className="col">
                          {
                            // merchant.packages && merchant.packages.length > 0 &&
                            //   merchant.packages.slice(0, 3).map((pkg, idx) => {
                            //     return (
                            //       <Link
                            //         key={idx}
                            //         to={{
                            //           pathname,
                            //           state: {
                            //             merchant,
                            //             package: pkg,
                            //             zipCode
                            //           }
                            //         }}
                            //       >
                            //         <Button
                            //           className="mx-1 mb-2"
                            //           color="primary"
                            //           size="sm"
                            //           type="button"
                            //         >
                            //           {pkg.title + ' ' + pkg.cost + '$'}
                            //         </Button>
                            //       </Link>
                            //     )
                            //   })
                          }
                          {merchant.vehicleType &&
                            merchant.vehicleType.length > 0 &&
                            merchant.vehicleType
                              .slice(0, 3)
                              .map((vType, idx) => {
                                return (
                                  <Link
                                    key={idx}
                                    to={{
                                      pathname,
                                      state: {
                                        merchant,
                                        vehicleType: vType,
                                        zipCode,
                                      },
                                    }}
                                  >
                                    <Button
                                      className="mx-1 mb-2"
                                      color="primary"
                                      size="sm"
                                      type="button"
                                    >
                                      {vType.title}
                                    </Button>
                                  </Link>
                                )
                              })}
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          )
        })}
      </>
    )
  }
  return (
    <Col>
      <p className="no-merchant-error">
        Sorry! No merchants available in this area.
      </p>
    </Col>
  )
}

export default MerchantsListCards
